(function () {
    const worksImages = document.querySelectorAll('.works-thumb__image img');
    const topWorksImages = document.querySelectorAll('.top-works-thumb__image img');

    function addImageClassBasedOnAspectRatio(images) {
      images.forEach(function (img) {
        img.onload = function () {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          const imageContainer = img.parentElement;

          // 横長か縦長かを判定してクラスを追加
          if (width > height) {
            imageContainer.classList.add('landscape');  // 横長
          } else if (width < height) {
            imageContainer.classList.add('portrait');   // 縦長
          } else {
            imageContainer.classList.add('square');     // 正方形の場合
          }
        };
      });
    }

  // 各画像リストに対して処理を実行
  if (worksImages.length > 0) {
    addImageClassBasedOnAspectRatio(worksImages);
  }

  if (topWorksImages.length > 0) {
    addImageClassBasedOnAspectRatio(topWorksImages);
  }

})();